import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/hooks/useAuth";

export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAdmin, isLoading: authLoading } = useAuth();
  const [hasSession, setHasSession] = useState<boolean | null>(null);
  const [sessionEmail, setSessionEmail] = useState<string | null>(null);
  const [routeLoading, setRouteLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function checkSession() {
      const { data } = await supabase.auth.getSession();
      if (!cancelled) {
        setHasSession(!!data.session);
        setSessionEmail(data.session?.user?.email || null);
        setRouteLoading(false);
      }
    }

    checkSession();

    return () => {
      cancelled = true;
    };
  }, []);

  // 路由層級的 session 檢查還在跑，顯示 loading
  if (routeLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="text-gray-500 text-sm">驗證權限中...</div>
      </div>
    );
  }

  // 沒有 session，踢去登入
  if (!hasSession) {
    return <Navigate to="/login" replace />;
  }

  // ✅ 絕對權限：admin@jishi-trade.com 無條件放行所有 /admin 路徑
  if (sessionEmail === "admin@jishi-trade.com") {
    return <>{children}</>;
  }

  // 有 session 但非 admin，等 useAuth 的 isAdmin 判定（處理 level=核心分銷的情況）
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="text-gray-500 text-sm">載入權限資料中...</div>
      </div>
    );
  }

  // 最終權限檢查
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
